export enum MonitorFilterDialogMessagesEnum {
	NoMonitorsSelectedTitle = 'There are no monitors in the system',
	NoMonitorsSelectedDescription = 'Connect at least one monitor or change filter params to identify it'
}
